import { render, staticRenderFns } from "./Iban.vue?vue&type=template&id=cca3dc0a&"
import script from "./Iban.vue?vue&type=script&lang=js&"
export * from "./Iban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports